export default __webpack_public_path__ + "static/media/gameEvent.a4790ae8.jpg";